import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatExecutionFormComponent } from './cat-execution-form/cat-execution-form.component';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';


const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form',
    component: CatExecutionFormComponent
  },
  {
    path: 'order-confirmation/:id',
    component: OrderConfirmationDetailsComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatExecutionRoutingModule { }
